let offset = 0;
let windowHeight = 0;

function waitForJQuery() {
    if (typeof jQuery !== "undefined") {
        setTimeout(setup, 500);
    } else {
        setTimeout(waitForJQuery, 250);
    }
}

waitForJQuery();

function setup() {
    setOffset();
    setupResizeListener();
    setupScrollListener();
}

function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
}

function setupResizeListener() {
    jQuery(window).on("resize", () => {
        setOffset();
    });
}

function setOffset() {
    const staticButton = jQuery(".cart__ctas.static");
    windowHeight = jQuery(window).height();
    offset = staticButton.offset().top;
}

function setupScrollListener() {
    jQuery(window).scroll(function () {
        debounce(handleScroll, 100);
    });

    handleScroll();
}

function handleScroll() {
    const stickyCartElement = jQuery(".cart__footer.sticky");

    if (jQuery(window).scrollTop() + windowHeight - stickyCartElement.height() < offset) {
        stickyCartElement.slideDown();
        document.dispatchEvent(new CustomEvent("sticky-bottom-element", { detail: { visible: true } }));
    } else {
        stickyCartElement.slideUp();
        document.dispatchEvent(new CustomEvent("sticky-bottom-element", { detail: { visible: false } }));
    }
}
